import { createFileRoute } from "@tanstack/react-router";
import { buildSeoMeta } from "@/lib/seo";

export const Route = createFileRoute("/legal/terms")({
  head: () => buildSeoMeta({
    title: "Terms of Service — RanchPlanner",
    description: "Terms of Service for RanchPlanner by 1uplift LLC.",
    path: "/legal/terms",
  }),
  component: TermsPage,
});

function TermsPage() {
  return (
    <div className="min-h-screen py-16 px-4">
      <div className="max-w-2xl mx-auto prose prose-neutral dark:prose-invert">
        <h1>Terms of Service</h1>
        <p className="text-muted-foreground">Last updated: April 14, 2026</p>

        <h2>1. Acceptance of Terms</h2>
        <p>By accessing RanchPlanner, you agree to these Terms of Service. RanchPlanner is operated by 1uplift LLC.</p>

        <h2>2. Description of Service</h2>
        <p>RanchPlanner provides AI-powered leisure activity recommendations in the Lakewood Ranch, FL area. We aggregate event data from public sources and apply intelligent curation.</p>

        <h2>3. Accuracy of Information</h2>
        <p>Event details (dates, times, costs) are sourced from third parties and may change without notice. Always verify with the event organizer before attending.</p>

        <h2>4. Permitted Use & Data Restrictions</h2>
        <p>RanchPlanner is intended for personal, non-commercial use only. You may not:</p>
        <ul>
          <li>Use automated tools, bots, scrapers, or crawlers to access, extract, or collect data from RanchPlanner without the express written permission of 1uplift LLC.</li>
          <li>Reproduce, redistribute, republish, or commercially exploit any data, event listings, recommendations, or other content obtained from RanchPlanner.</li>
          <li>Access RanchPlanner on behalf of a competing business, data aggregator, or any commercial entity for the purpose of gathering, copying, or monitoring content.</li>
          <li>Circumvent any technical measures designed to restrict automated access.</li>
        </ul>
        <p>Any use of RanchPlanner data for purposes other than personal leisure planning requires express written permission from 1uplift LLC. Unauthorized use may result in legal action and termination of access.</p>

        <h2>5. Limitation of Liability</h2>
        <p>RanchPlanner and 1uplift LLC are not liable for any damages arising from use of the service or reliance on event information.</p>

        <h2>6. Governing Law</h2>
        <p>These Terms of Service and any dispute arising from them shall be governed by and construed in accordance with the laws of the State of New Mexico, without regard to its conflict of law principles.</p>

        <h2>7. Contact</h2>
        <p>Questions about these terms may be directed to <a href="mailto:support@1uplift.com">support@1uplift.com</a>.</p>
      </div>
    </div>
  );
}
